module.exports = __webpack_public_path__ + "img/oficina-salcedo.d1fade02.jpg";